import { call } from "./apiCaller";
import config from "../config/runtimeConfig";

export function dispatchItem(type, data) {
  return (dispatch) => {
    dispatch({ type: type, data: data });
  };
}

export function login(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_AUTHENTICATION_LOGIN,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function generateToken(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_AUTHENTICATION_GENERATE_TOKEN,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function otpSms(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_AUTHENTICATION_OTPSMS,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function forgotPassword(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_AUTHENTICATION_FORGOTPASSWORD,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function changePassword(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_AUTHENTICATION_CHANGEPASSWORD,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function checkSignatureResult(transactionId, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      `${config.APIURLS_AUTHENTICATION_SIGNATURE_RESULT}?transactionId=${transactionId}`,
      "post",
      null,
      successFunc,
      errorFunc,
      false, // isBlobRequest
      false, // preventBlobDownload
      true, // skipLoading (polling'de spinner gösterme)
    );
  };
}

export function cancelSignaturePolling(transactionId, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      `${config.APIURLS_AUTHENTICATION_SIGNATURE_CANCEL}?transactionId=${transactionId}`,
      "post",
      null,
      successFunc,
      errorFunc,
      false, // isBlobRequest
      false, // preventBlobDownload
      true, // skipLoading
    );
  };
}

export function userVerification(
  data,
  successFunc,
  errorFunc,
  verificationCode,
) {
  return (dispatch) => {
    call(
      config.APIURLS_AUTHENTICATION_USERVERIFICATION.replace(
        "{verificationCode}",
        verificationCode,
      ),
      "get",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function validateFile(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(config.APIURLS_VALIDATEFILE, "post", data, successFunc, errorFunc);
  };
}

export function companies(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_SALESAGENT_COMPANIES_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function allClients(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_CLIENTS_LIST_ALL,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function activateCompany(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_SALESAGENT_COMPANIES_ACTIVATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function deactivateCompany(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_SALESAGENT_COMPANIES_DEACTIVATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function updateCompany(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_SALESAGENT_COMPANIES_UPDATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function createCompany(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_SALESAGENT_COMPANIES_CREATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function activateUser(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_SALESAGENT_USERS_ACTIVATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function deactivateUser(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_SALESAGENT_USERS_DEACTIVATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function resendUser(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_SALESAGENT_USERS_RESEND,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function updateUser(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_SALESAGENT_USERS_UPDATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function createUser(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_SALESAGENT_USERS_CREATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function updateProduct(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_SALESAGENT_PRODUCTS_UPDATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function createProduct(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_SALESAGENT_PRODUCTS_CREATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function createPartner(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_PARTNERS_CREATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function getAllUserList(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_PARTNERS_GETALLUSER,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function createClient(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_CLIENTS_CREATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function updateClient(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_CLIENT_UPDATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function groups(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(config.APIURLS_USER_GROUPS_LIST, "post", data, successFunc, errorFunc);
  };
}

export function updateGroup(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_GROUPS_UPDATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function createGroup(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_GROUPS_CREATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function deleteGroup(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_GROUPS_DELETE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function receivers(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_RECEIVERS_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function createReceiver(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_RECEIVERS_CREATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function uploadReceiver(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_RECEIVERS_UPLOAD,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function deleteReceiver(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_RECEIVERS_DELETE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function blacklist(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_BLACKLIST_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function createBlacklist(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_BLACKLIST_CREATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function uploadBlacklist(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_BLACKLIST_UPLOAD,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function deleteBlacklist(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_BLACKLIST_DELETE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function deleteBlacklistAll(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_BLACKLIST_DELETEALL,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function blackhour(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_BLACKHOUR_GET,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function setBlackhour(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_BLACKHOUR_SET,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function sendSmsByFile(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_SMS_SENDBYFILE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function sendSmsByGroupId(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_SMS_SENDBYGROUPID,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function sendSmsBySingle(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_SMS_SENDBYSINGLE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function userReport(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(config.APIURLS_USER_REPORT_LIST, "post", data, successFunc, errorFunc);
  };
}

export function reportDownload(bmspGroupId, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_REPORT_DOWNLOAD_URL.replace("{groupId}", bmspGroupId),
      "post",
      {},
      successFunc,
      errorFunc,
      true,
    );
  };
}

export function userLastReport(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_REPORT_LASTLIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function partners(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_PARTNERS_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function createSuperAdmin(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_SUPER_ADMIN_CREATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function clients(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_CLIENTS_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function drafts(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_DRAFT_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function client(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_CLIENT,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function draft(draftId, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_DRAFT.replace("{draftId}", draftId),
      "get",
      {},
      successFunc,
      errorFunc,
    );
  };
}

export function clientContract(xCustomerId, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_CLIENT_CONTRACT.replace(
        "{xCustomerId}",
        xCustomerId,
      ),
      "get",
      {},
      successFunc,
      errorFunc,
      true,
    );
  };
}

export function queries(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_QUERIES_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function query(data, successFunc, errorFunc) {
  if (data.isAdmin) {
    return (dispatch) => {
      call(
        config.APIURLS_XIVODAFONE_QUERY_ADMIN,
        "post",
        data,
        successFunc,
        errorFunc,
      );
    };
  }
  return (dispatch) => {
    call(config.APIURLS_XIVODAFONE_QUERY, "post", data, successFunc, errorFunc);
  };
}

export function deleteQuery(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_QUERIES_DELETE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function xiVodafoneReportClientList(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_REPORT_CLIENTS_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function xiVodafoneReportQuota(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_REPORT_QUOTA_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function xiVodafoneReportSend(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_REPORT_SEND_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function xiVodafoneReportSendDownload(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_REPORT_SEND_DOWNLOAD.replace(
        "{xCustomerId}",
        data.xCustomerId,
      ),
      "post",
      data,
      successFunc,
      errorFunc,
      true,
    );
  };
}

export function xiVodafoneReportCancelSend(reportId, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_REPORT_CANCEL_SEND.replace(
        "{reportId}",
        reportId,
      ),
      "post",
      {},
      successFunc,
      errorFunc,
    );
  };
}

export function queryConfig(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_QUERY_CONFIG,
      "get",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function updateQuery(data, successFunc, errorFunc) {
  return (dispatch) => {
    let newData = { params: {} };
    newData.params = data.queryParams;
    let editedDataQueryParams = editData(newData);
    data.queryParams = editedDataQueryParams.params;
    call(
      config.APIURLS_XIVODAFONE_QUERY_UPDATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function createQuery(data, successFunc, errorFunc) {
  return (dispatch) => {
    let editDataParams = { params: {} };
    editDataParams.params = data.queryParams;
    data.queryParams = editData(editDataParams).params;
    call(
      config.APIURLS_XIVODAFONE_QUERY_CREATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function findTargetQuery(data, successFunc, errorFunc) {
  return (dispatch) => {
    let editedData = editData(data);
    call(
      config.APIURLS_XIVODAFONE_QUERY_FINDTARGET,
      "post",
      editedData,
      successFunc,
      errorFunc,
    );
  };
}

export function sendQuery(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_QUERY_SEND,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function sendInfo(sendId, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_QUERY_SEND_INFO.replace("{sendId}", sendId),
      "post",
      {},
      successFunc,
      errorFunc,
    );
  };
}

export function sendFileInfo(sendId, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_QUERY_SEND_INFO_FILE.replace(
        "{sendId}",
        sendId,
      ),
      "get",
      {},
      successFunc,
      errorFunc,
      true,
      true,
    );
  };
}

export function sendEdit(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_QUERY_SEND_EDIT,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function testSmsQuery(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_QUERY_TESTSMS,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function saveDraft(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_DRAFT_SAVE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function updateDraft(draftId, data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_DRAFT_UPDATE.replace("{draftId}", draftId),
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function draftFile(draftId, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_DRAFT_FILE.replace("{draftId}", draftId),
      "get",
      {},
      successFunc,
      errorFunc,
      true,
      true,
    );
  };
}

export function finishDraft(draftId, data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_DRAFT_FINISH.replace("{draftId}", draftId),
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function deleteDraft(draftId, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_DRAFT_DELETE.replace("{draftId}", draftId),
      "delete",
      {},
      successFunc,
      errorFunc,
    );
  };
}

export function smsVerification(
  data,
  successFunc,
  errorFunc,
  verificationCode,
) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_SMSVERIFICATION.replace(
        "{verificationCode}",
        verificationCode,
      ),
      "get",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function xiVodafonePartnerReportMonthly(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_PARTNERREPORT_MONTHLY_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function xiVodafonePartnerReportQuota(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_PARTNERREPORT_QUOTA_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function xiVodafonePartnerReportQuotaDownload(
  data,
  successFunc,
  errorFunc,
) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_PARTNERREPORT_QUOTA_DOWNLOAD.replace(
        "{xCustomerId}",
        data.xCustomerId,
      ),
      "post",
      data,
      successFunc,
      errorFunc,
      true,
    );
  };
}

export function xiVodafonePartnerReportSend(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_PARTNERREPORT_SEND_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function xiVodafonePartnerReportSendDownload(
  data,
  successFunc,
  errorFunc,
) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_PARTNERREPORT_SEND_DOWNLOAD,
      "post",
      data,
      successFunc,
      errorFunc,
      true,
    );
  };
}

export function originators(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(config.APIURLS_ORIGINATORS, "post", data, successFunc, errorFunc);
  };
}

export function partnerInfos(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(config.APIURLS_PARTNERINFOS, "post", data, successFunc, errorFunc);
  };
}

export function companyBrandCodes(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_COMPANY_BRAND_CODE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}
export function editData(data) {
  let newData = { params: { groups: [], type: "" } };

  for (let group of data.params.groups) {
    let newGroup = { rules: [] };
    let newRules = [];
    for (let rule of group.rules) {
      if (rule.type === "MULTISELECT_TINYINT") {
        for (let value of rule.values) {
          let newRule = {};
          let newValue = ["1"];
          newRule.ruleId = rule.ruleId;
          newRule.subruleId = value;
          newRule.values = newValue;
          newRule.operator = "EQ";
          newRule.type = "MULTISELECT_TINYINT";
          newRules.push(newRule);
        }
      } else {
        newRules.push(rule);
      }
    }
    newGroup.type = group.type;
    newGroup.rules = newRules;
    newData.params.groups.push(newGroup);
  }
  newData.params.type = data.params.type;
  return newData;
}

export function searchCurCompany(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_SALESAGENT_CURCOMPANIES_SEARCH,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function createCurCompany(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_SALESAGENT_CURCOMPANIES_CREATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function generalStatusReport(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_GENERAL_STATUS_REPORT_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function dailyReport(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_DAILY_REPORT_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function errorCodeReport(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_ERROR_CODE_REPORT_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function errorCodeByMsisdnReport(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_ERROR_CODE_MSISDN_REPORT_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function invoiceReport(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_INVOICE_REPORT_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function invoiceDetailReport(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_INVOICE_DETAIL_REPORT_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function virtualNumberList(successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_VIRTUAL_NUMBER_LIST,
      "post",
      {},
      successFunc,
      errorFunc,
    );
  };
}

export function exportOmsgReport(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_USER_EXPORT_REPORT,
      "post",
      data,
      successFunc,
      errorFunc,
      true,
    );
  };
}

export function getAdminUserList(successFunc, errorFunc) {
  return call(
    config.APIURLS_ADMIN_USER_LIST,
    "post",
    {},
    successFunc,
    errorFunc,
  );
}

export function getAdminReportList(successFunc, errorFunc) {
  return call(
    config.APIURLS_ADMIN_REPORT_LIST,
    "post",
    {},
    successFunc,
    errorFunc,
  );
}

export function updateUserDetail(data, successFunc, errorFunc) {
  return call(
    config.APIURLS_ADMIN_USER_UPDATE,
    "post",
    data,
    successFunc,
    errorFunc,
  );
}

export function removeAllCache() {
  return (dispatch) => {
    dispatch({ type: "REMOVE_ALL" });
  };
}

export function getSmsApproveList(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_ADMIN_SMS_APPROVE_LIST,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function getPartnerQuery(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_QUERY_PARTNER,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function queryFile(queryId, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_QUERY_FILE.replace("{queryId}", queryId),
      "get",
      {},
      successFunc,
      errorFunc,
      true,
      true,
    );
  };
}

export function sendSmsApprove(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_ADMIN_SMS_APPROVE_SEND,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function sendSmsDetailUpdate(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_SMS_DETAIL_UPDATE_SEND,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function approveMaximo(id, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_APPROVE_MAXIMO.replace("{id}", id),
      "post",
      {},
      successFunc,
      errorFunc,
    );
  };
}
export function adminReportUpdateStatus(reportId, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_REPORT_UPDATE_STATUS.replace("{reportId}", reportId),
      "post",
      {},
      successFunc,
      errorFunc,
    );
  };
}

export function deletePartnerUser(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_SALESAGENT_PARTNERS_DELETE_USER,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function deletePartner(partnerId, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_SALESAGENT_PARTNER_DELETE.replace(
        "{partnerId}",
        partnerId,
      ),
      "get",
      {},
      successFunc,
      errorFunc,
    );
  };
}

export function createPartnerUser(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_SALESAGENT_PARTNER_USERS_CREATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}

export function createSalesUser(data, successFunc, errorFunc) {
  return (dispatch) => {
    call(
      config.APIURLS_XIVODAFONE_SALES_USER_CREATE,
      "post",
      data,
      successFunc,
      errorFunc,
    );
  };
}
